import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColGroupDef, ICellRendererParams } from "ag-grid-enterprise";
import { ElectrodeEvent } from "../../../../models/eaf.models";
import { isTimestampBetweenStartAndEnd } from "../../../../utils/isTimesTampBetweenStartAndEnd";
import { EditAndDeleteButtons } from "../../components/EditAndDeleteButtons";

type Props = {
	deleteElectrodeEvent: (electrodeEventId: number) => void;
	editElectrodeEvent: (electrodeEventId: number) => void;
	processStart?: Date;
	processEnd?: Date | null;
};

export const useTableData = ({
	deleteElectrodeEvent,
	editElectrodeEvent,
	processStart,
	processEnd,
}: Props) => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Electrodes",
			headerStyle: {
				fontSize: "0.9rem",
			},
			children: [
				{
					field: "Phase",
					headerName: "Phase",
					flex: 1,
					minWidth: 61,
				},
				{
					field: "Timestamp",
					headerName: "Time",
					flex: 1,
					minWidth: 59,
					valueGetter: (params: any) => {
						if (params.data.Timestamp) {
							return dxtToLocalServerTime(params.data.Timestamp, "HH:mm");
						}
					},
					cellStyle: (params: any) => {
						const electrodeEvent = params.data as ElectrodeEvent;
						const isManual = electrodeEvent.IsManual;
						const timestamp = new Date(electrodeEvent.Timestamp);

						if (
							isManual &&
							processStart &&
							!isTimestampBetweenStartAndEnd(
								timestamp,
								processStart,
								processEnd ?? null,
							)
						) {
							return {
								backgroundColor: "#ffebee",
								border: "1px solid #f44336",
								color: "#c62828",
							};
						}
						return null;
					},
				},
				{
					field: "PhaseEventType",
					headerName: "Event",
					flex: 3,
					minWidth: 50,
					wrapText: true,
					autoHeight: true,
				},
				{
					field: "actions",
					headerName: " ",
					flex: 1,
					minWidth: 80,
					maxWidth: 80,
					cellRenderer: EditAndDeleteButtons,
					cellRendererParams: (params: ICellRendererParams) => ({
						deleteItem: deleteElectrodeEvent,
						edit: editElectrodeEvent,
						id: (params.data as ElectrodeEvent).ElectrodeEventId,
					}),
				},
			],
		},
	];

	return { columns };
};
